export const certificateValidityStatusIds = {
  Valid: "c47a0b7c-701b-5544-92b0-6bcb48aac633",
  Expired: "63a507c8-7124-5eec-8510-02b74a3a8dca",
  WithdrawnNotReplaced: "64e89d04-9533-57f4-8f2d-41f340a29d8b",
  WithdrawnReplacedBy: "38fa47c8-12a4-5e6f-b9d1-387d3c8222b8",
  ValidExtendedBy: "02ab294a-cfe3-57d0-8831-2d600c44397c",
  Void: "258a9d1a-5070-562a-a14f-2973c2c70d84",
} as const;
